const mainColorValue = '53, 125, 66';

const theme = {
  color: {
    primary: '#357D42',
    primaryValues: '53 125 66',
    secondary: '#d1fae5',
    background: `rgba(${mainColorValue}, 0.1)`,
    backgroundContent: '#eaf2ec',
    textPrimary: '#1e293b',
    textSecondary: '#808e9f',
    textDisabled: '#94a3b8',
    buttonText: '#ffffff',
    buttonHoverText: '#262626',
    buttonBg: '#508b5c',
    buttonHoverBg: '#34d399',
    buttonSelectedBg: '#10172a',
  },
  screens: {
    sm: '640px',
    // => @media (min-width: 640px) { ... }

    md: '768px',
    // => @media (min-width: 768px) { ... }

    lg: '1024px',
    // => @media (min-width: 1024px) { ... }

    xl: '1280px',
    // => @media (min-width: 1280px) { ... }

    '2xl': '1536px',
    // => @media (min-width: 1536px) { ... }
  },
  fontSize: {
    xs: '0.85rem',
    sm: '0.9rem',
    base: '0.95rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    '4xl': '2.5rem',
    '5xl': '3rem',
  },
  backgroundImage: {
    gradient: `radial-gradient(circle at 25% 25%, rgba(${mainColorValue}, 0.4) 0%, rgba(${mainColorValue}, 0) 70%), radial-gradient(circle at 75% 75%, rgba(${mainColorValue}, 0.2) 0%, rgba(${mainColorValue}, 0) 70%)`,
    'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
    'gradient-conic':
      'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))',
  },
  boxShadow: {
    customFocus: `0 0 0 4px rgba(${mainColorValue}, .2)`,
    dropShadow: `0 -1px 0 rgb(${mainColorValue})`,
    shadow: `0 0 0 1px rgba(255, 255, 255, .25)`,
    xs: [
      '0px 0.2px 0.2px rgba(0, 0, 0, 0.012)',
      '0px 0.5px 0.4px rgba(0, 0, 0, 0.016)',
      '0px 1px 0.8px rgba(0, 0, 0, 0.02)',
      '0px 1.8px 1.3px rgba(0, 0, 0, 0.024)',
      '0px 3.3px 2.5px rgba(0, 0, 0, 0.028)',
      '0px 8px 6px rgba(0, 0, 0, 0.04)',
    ],
    sm: [
      '0px 0.3px 0.3px rgba(0, 0, 0, 0.012)',
      '0px 0.7px 0.7px rgba(0, 0, 0, 0.016)',
      '0px 1.3px 1.3px rgba(0, 0, 0, 0.02)',
      '0px 2.2px 2.2px rgba(0, 0, 0, 0.024)',
      '0px 4.2px 4.2px rgba(0, 0, 0, 0.028)',
      '0px 10px 10px rgba(0, 0, 0, 0.04)',
    ],
    md: [
      '0px 0.4px 0.4px rgba(0, 0, 0, 0.012)',
      '0px 1px 0.9px rgba(0, 0, 0, 0.016)',
      '0px 1.9px 1.8px rgba(0, 0, 0, 0.02)',
      '0px 3.4px 3.1px rgba(0, 0, 0, 0.024)',
      '0px 6.3px 5.8px rgba(0, 0, 0, 0.028)',
      '0px 15px 14px rgba(0, 0, 0, 0.04)',
    ],
    lg: [
      '0px 0.6px 0.6px rgba(0, 0, 0, 0.012)',
      '0px 1.3px 1.3px rgba(0, 0, 0, 0.016)',
      '0px 2.5px 2.5px rgba(0, 0, 0, 0.02)',
      '0px 4.5px 4.5px rgba(0, 0, 0, 0.024)',
      '0px 8.4px 8.4px rgba(0, 0, 0, 0.028)',
      '0px 20px 20px rgba(0, 0, 0, 0.04)',
    ],
    xl: [
      '0px 0.9px 0.9px rgba(0, 0, 0, 0.012)',
      '0px 2.1px 2.1px rgba(0, 0, 0, 0.016)',
      '0px 4px 4px rgba(0, 0, 0, 0.02)',
      '0px 7.1px 7.1px rgba(0, 0, 0, 0.024)',
      '0px 13.4px 13.4px rgba(0, 0, 0, 0.028)',
      '0px 32px 32px rgba(0, 0, 0, 0.04)',
    ],
    '2xl': [
      '0px 1.4px 1.4px rgba(0, 0, 0, 0.012)',
      '0px 3.3px 3.3px rgba(0, 0, 0, 0.016)',
      '0px 6.3px 6.3px rgba(0, 0, 0, 0.02)',
      '0px 11.2px 11.2px rgba(0, 0, 0, 0.024)',
      '0px 20.9px 20.9px rgba(0, 0, 0, 0.028)',
      '0px 50px 50px rgba(0, 0, 0, 0.04)',
    ],
  },
  keyframes: {
    slideOutLeft: {
      '100%': {
        transform: 'translateX(-2rem)',
        opacity: '0',
      },
      '0%': {
        transform: 'translateX(0)',
        opacity: '1',
      },
    },
    slideOutRight: {
      '100%': {
        transform: 'translateX(2rem)',
        opacity: '0',
      },
      '0%': {
        transform: 'translateX(0)',
        opacity: '1',
      },
    },
    slideOutTop: {
      '100%': {
        transform: 'translateY(-2rem)',
        opacity: '0',
        visibility: 'hidden',
      },
      '0%': {
        transform: 'translateY(0)',
        opacity: '1',
        visibility: 'visible',
      },
    },
    slideOutBottom: {
      '100%': {
        transform: 'translateY(2rem)',
        opacity: '0',
        visibility: 'hidden',
      },
      '0%': {
        transform: 'translateY(0)',
        opacity: '1',
        visibility: 'visible',
      },
    },
    slideInLeft: {
      '0%': {
        transform: 'translateX(-2rem)',
        opacity: '0',
      },
      '100%': {
        transform: 'translateX(0)',
        opacity: '1',
      },
    },
    slideInRight: {
      '0%': {
        transform: 'translateX(2rem)',
        opacity: '0',
      },
      '100%': {
        transform: 'translateX(0)',
        opacity: '1',
      },
    },
    slideInTop: {
      '0%': {
        transform: 'translateY(-2rem)',
        opacity: '0',
      },
      '100%': {
        transform: 'translateY(0)',
        opacity: '1',
      },
    },
    slideInBottom: {
      '0%': {
        transform: 'translateY(2rem)',
        opacity: '0',
      },
      '100%': {
        transform: 'translateY(0)',
        opacity: '1',
      },
    },
    // Tooltip
    slideUpFade: {
      '0%': { opacity: 0, transform: 'translateY(2rem)' },
      '100%': { opacity: 1, transform: 'translateY(0)' },
    },
    slideRightFade: {
      '0%': { opacity: 0, transform: 'translateX(-2px)' },
      '100%': { opacity: 1, transform: 'translateX(0)' },
    },
    slideDownFade: {
      '0%': { opacity: 0, transform: 'translateY(-2px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' },
    },
    slideLeftFade: {
      '0%': { opacity: 0, transform: 'translateX(2px)' },
      '100%': { opacity: 1, transform: 'translateX(0)' },
    },
    // Navigation menu
    enterFromRight: {
      '0%': { transform: 'translateX(200px)', opacity: 0 },
      '100%': { transform: 'translateX(0)', opacity: 1 },
    },
    enterFromLeft: {
      '0%': { transform: 'translateX(-200px)', opacity: 0 },
      '100%': { transform: 'translateX(0)', opacity: 1 },
    },
    exitToRight: {
      '0%': { transform: 'translateX(0)', opacity: 1 },
      '100%': { transform: 'translateX(200px)', opacity: 0 },
    },
    exitToLeft: {
      '0%': { transform: 'translateX(0)', opacity: 1 },
      '100%': { transform: 'translateX(-200px)', opacity: 0 },
    },
    scaleInContent: {
      '0%': { transform: 'rotateX(-30deg) scale(0.9)', opacity: 0 },
      '100%': { transform: 'rotateX(0deg) scale(1)', opacity: 1 },
    },
    scaleOutContent: {
      '0%': { transform: 'rotateX(0deg) scale(1)', opacity: 1 },
      '100%': { transform: 'rotateX(-10deg) scale(0.95)', opacity: 0 },
    },
    faceIn: {
      '0%': { opacity: 0 },
      '100%': { opacity: 1 },
    },
    fadeOut: {
      '0%': { opacity: 1 },
      '100%': { opacity: 0 },
    },
    rotate: {
      '0%': {
        transform: 'rotate(0)',
      },
      '-50%': {
        transform: 'rotate(-180deg)',
      },
      '50%': {
        transform: 'rotate(180deg)',
      },
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
  },
  animation: {
    fadeIn: 'faceIn 0.1s ease-in-out both',
    fadeOut: 'faceOut 0.4s ease-in-out both',
    rotate: 'rotate 12s linear infinite',
    slideInLeft: 'slideInLeft 0.4s cubic-bezier(0.7, 0, 0.1, 1) both',
    slideInRight: 'slideInRight 0.4s cubic-bezier(0.7, 0, 0.1, 1) both',
    slideInTop: 'slideInTop 0.4s cubic-bezier(0.7, 0, 0.1, 1) both',
    slideInBottom: 'slideInBottom 0.4s cubic-bezier(0.7, 0, 0.1, 1) both',
    slideOutLeft: 'slideOutLeft 0.4s cubic-bezier(0.7, 0, 0.1, 1) both',
    slideOutRight: 'slideOutRight 0.4s cubic-bezier(0.7, 0, 0.1, 1) both',
    slideOutTop: 'slideOutTop 0.4s cubic-bezier(0.7, 0, 0.1, 1) both',
    slideOutBottom: 'slideOutBottom 0.4s cubic-bezier(0.7, 0, 0.1, 1) both',
  },
};

export default theme;
